<template>
  <SdsAvatarGroup
    density="default"
    shape="circle"
    size="sm"
    :srcset="srcset"
  />
</template>

<script setup lang="ts">
import { inject } from 'vue'
const dataset = inject('dataset')

const srcset = JSON.parse(dataset['srcset'])

defineOptions({
  name: "GenericAvatarGroup"
})
</script>
